import Controller from 'lib/controller'
import Collection from 'collection/collection'
import dataProvider from 'service/data_provider'
import LocalcommunitySelectorComponent from 'component/community_selector/localcommunity_selector'
import browsingCommunity from 'shared/model/browsing_community'
import currentUserLocationModel from 'shared/model/current_user_location'
import currentUserModel from 'shared/model/current_user'
import communityChanger from 'component/community_changer'
import CommunityLinkView from 'bundle/localcommunity/view/community_link'
import UserLocationModel from 'model/user_location'

const Ctrl = Controller.extend({
    el: 'body',

    bubbleEvents: {
        'CommunitySearchResult:select': '_selectCommunity',
    },

    initialize() {
        this._initCommunityLinks()
        if (currentUserModel.isLoggedIn()) {
            this._initCommunitySelectorLoggedIn()
        } else {
            this._initCommunitySelectorLoggedOut()
        }
    },

    _initCommunityLinks() {
        const collection = new Collection(dataProvider.get('markers'))
        const communities = collection.reduce((acc, val) => ({ ...acc, [val.id]: val }), {})

        this.$('.js-community-link').each((index, element) => {
            const data = this.$(element).data()
            const model = communities[data.id]

            this.initSubview(CommunityLinkView, {
                el: element,
                model,
            })
        })
    },

    _initCommunitySelectorLoggedIn() {
        currentUserLocationModel.fetchOnce().then(() => {
            this.initSubview(LocalcommunitySelectorComponent, {
                el: '.js-local-community-selector',
                model: currentUserLocationModel,
                // browsing community will be directly modified
                communityModel: browsingCommunity,
            }).render()
        })
    },

    _initCommunitySelectorLoggedOut() {
        // Try to get coordinates from user IP or use Paris coordinates as fallback
        const coordinates = dataProvider.get('loggedOutCoordinates') || { latitude: 48.856667, longitude: 2.351667 }
        const userLocationModel = new UserLocationModel({ coordinates })

        this.initSubview(LocalcommunitySelectorComponent, {
            el: '.js-local-community-selector',
            model: userLocationModel,
        }).render()
    },

    _selectCommunity(payload) {
        if (currentUserModel.isLoggedIn()) {
            // community switch for logged-in user will be handled by header code
            return
        }

        communityChanger.loadSeoPage(payload.community.toJSON())
    },
})

export default new Ctrl()
